import { List, Map } from 'immutable';

const getCategoriesFromOrganization = (organization) => {
  const categories = Map.isMap(organization) ? organization.get('roundCategories', List()) : List();

  return List.isList(categories) ? categories : List();
};

export default getCategoriesFromOrganization;
